import {v4} from 'uuid'
const  destinations = [
    {
        id: v4(),
        imgSrc: 'Airbnb/images/destinations/flexible.jpg',
        name:'Flexible',
    },
    {
        id: v4(),
        imgSrc: 'Airbnb/images/destinations/europe.jpg',
        name:'Eroupe',
    },
    {
        id: v4(),
        imgSrc: 'Airbnb/images/destinations/thailan.jpg',
        name:'Thailand',
    },
    {
        id: v4(),
        imgSrc: 'Airbnb/images/destinations/united-states.jpg',
        name:'United States',
    },
    {
        id: v4(),
        imgSrc: 'Airbnb/images/destinations/south-korea.jpg',
        name:'South Korea',
    },
    {
        id: v4(),
        imgSrc: 'Airbnb/images/destinations/australia.jpg',
        name:'Australia',
    },
    {
        id: v4(),
        imgSrc: 'Airbnb/images/destinations/italy.jpg',
        name:'Italy',
    },
    {
        id: v4(),
        imgSrc: 'Airbnb/images/destinations/south-america.jpg',
        name:'South America',
    },
    {
        id: v4(),
        imgSrc: 'Airbnb/images/destinations/united-kingdom.jpg',
        name:'United Kingdom',
    },
]
export default destinations